/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  GovernorModule,
  GovernorModuleInterface,
} from "../../../../contracts/mocks/governor/GovernorModule";

const _abi = [
  {
    inputs: [],
    name: "Empty",
    type: "error",
  },
  {
    inputs: [],
    name: "NotAuthorized",
    type: "error",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "previousAdmin",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "newAdmin",
        type: "address",
      },
    ],
    name: "AdminChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "beacon",
        type: "address",
      },
    ],
    name: "BeaconUpgraded",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint8",
        name: "version",
        type: "uint8",
      },
    ],
    name: "Initialized",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "proposalId",
        type: "uint256",
      },
    ],
    name: "ProposalCanceled",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "proposalId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "proposer",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address[]",
        name: "targets",
        type: "address[]",
      },
      {
        indexed: false,
        internalType: "uint256[]",
        name: "values",
        type: "uint256[]",
      },
      {
        indexed: false,
        internalType: "string[]",
        name: "signatures",
        type: "string[]",
      },
      {
        indexed: false,
        internalType: "bytes[]",
        name: "calldatas",
        type: "bytes[]",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "startBlock",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "endBlock",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "string",
        name: "description",
        type: "string",
      },
    ],
    name: "ProposalCreated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "proposalId",
        type: "uint256",
      },
    ],
    name: "ProposalExecuted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "proposalId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "eta",
        type: "uint256",
      },
    ],
    name: "ProposalQueued",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "oldProposalThreshold",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "newProposalThreshold",
        type: "uint256",
      },
    ],
    name: "ProposalThresholdSet",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "oldQuorumNumerator",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "newQuorumNumerator",
        type: "uint256",
      },
    ],
    name: "QuorumNumeratorUpdated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "oldTimelock",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "newTimelock",
        type: "address",
      },
    ],
    name: "TimelockChange",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "implementation",
        type: "address",
      },
    ],
    name: "Upgraded",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "voter",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "proposalId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint8",
        name: "support",
        type: "uint8",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "weight",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "string",
        name: "reason",
        type: "string",
      },
    ],
    name: "VoteCast",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "voter",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "proposalId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint8",
        name: "support",
        type: "uint8",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "weight",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "string",
        name: "reason",
        type: "string",
      },
      {
        indexed: false,
        internalType: "bytes",
        name: "params",
        type: "bytes",
      },
    ],
    name: "VoteCastWithParams",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "oldVotingDelay",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "newVotingDelay",
        type: "uint256",
      },
    ],
    name: "VotingDelaySet",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "oldVotingPeriod",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "newVotingPeriod",
        type: "uint256",
      },
    ],
    name: "VotingPeriodSet",
    type: "event",
  },
  {
    inputs: [],
    name: "BALLOT_TYPEHASH",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "COUNTING_MODE",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "EXTENDED_BALLOT_TYPEHASH",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "accessControl",
    outputs: [
      {
        internalType: "contract IDAOAccessControl",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "proposalId",
        type: "uint256",
      },
      {
        internalType: "uint8",
        name: "support",
        type: "uint8",
      },
    ],
    name: "castVote",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "proposalId",
        type: "uint256",
      },
      {
        internalType: "uint8",
        name: "support",
        type: "uint8",
      },
      {
        internalType: "uint8",
        name: "v",
        type: "uint8",
      },
      {
        internalType: "bytes32",
        name: "r",
        type: "bytes32",
      },
      {
        internalType: "bytes32",
        name: "s",
        type: "bytes32",
      },
    ],
    name: "castVoteBySig",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "proposalId",
        type: "uint256",
      },
      {
        internalType: "uint8",
        name: "support",
        type: "uint8",
      },
      {
        internalType: "string",
        name: "reason",
        type: "string",
      },
    ],
    name: "castVoteWithReason",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "proposalId",
        type: "uint256",
      },
      {
        internalType: "uint8",
        name: "support",
        type: "uint8",
      },
      {
        internalType: "string",
        name: "reason",
        type: "string",
      },
      {
        internalType: "bytes",
        name: "params",
        type: "bytes",
      },
    ],
    name: "castVoteWithReasonAndParams",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "proposalId",
        type: "uint256",
      },
      {
        internalType: "uint8",
        name: "support",
        type: "uint8",
      },
      {
        internalType: "string",
        name: "reason",
        type: "string",
      },
      {
        internalType: "bytes",
        name: "params",
        type: "bytes",
      },
      {
        internalType: "uint8",
        name: "v",
        type: "uint8",
      },
      {
        internalType: "bytes32",
        name: "r",
        type: "bytes32",
      },
      {
        internalType: "bytes32",
        name: "s",
        type: "bytes32",
      },
    ],
    name: "castVoteWithReasonAndParamsBySig",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "targets",
        type: "address[]",
      },
      {
        internalType: "uint256[]",
        name: "values",
        type: "uint256[]",
      },
      {
        internalType: "bytes[]",
        name: "calldatas",
        type: "bytes[]",
      },
      {
        internalType: "bytes32",
        name: "descriptionHash",
        type: "bytes32",
      },
    ],
    name: "execute",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "blockNumber",
        type: "uint256",
      },
    ],
    name: "getVotes",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "blockNumber",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "params",
        type: "bytes",
      },
    ],
    name: "getVotesWithParams",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "proposalId",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "hasVoted",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "targets",
        type: "address[]",
      },
      {
        internalType: "uint256[]",
        name: "values",
        type: "uint256[]",
      },
      {
        internalType: "bytes[]",
        name: "calldatas",
        type: "bytes[]",
      },
      {
        internalType: "bytes32",
        name: "descriptionHash",
        type: "bytes32",
      },
    ],
    name: "hashProposal",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IVotesUpgradeable",
        name: "_token",
        type: "address",
      },
      {
        internalType: "contract ITimelock",
        name: "_timelock",
        type: "address",
      },
      {
        internalType: "uint64",
        name: "_initialVoteExtension",
        type: "uint64",
      },
      {
        internalType: "uint256",
        name: "_initialVotingDelay",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_initialVotingPeriod",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_initialProposalThreshold",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_initialQuorumNumeratorValue",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "_accessControl",
        type: "address",
      },
    ],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "moduleFactory",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]",
      },
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]",
      },
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    name: "onERC1155BatchReceived",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    name: "onERC1155Received",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    name: "onERC721Received",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "proposalId",
        type: "uint256",
      },
    ],
    name: "proposalDeadline",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "proposalId",
        type: "uint256",
      },
    ],
    name: "proposalEta",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "proposalId",
        type: "uint256",
      },
    ],
    name: "proposalSnapshot",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "proposalThreshold",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "proposalId",
        type: "uint256",
      },
    ],
    name: "proposalVotes",
    outputs: [
      {
        internalType: "uint256",
        name: "againstVotes",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "forVotes",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "abstainVotes",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "targets",
        type: "address[]",
      },
      {
        internalType: "uint256[]",
        name: "values",
        type: "uint256[]",
      },
      {
        internalType: "bytes[]",
        name: "calldatas",
        type: "bytes[]",
      },
      {
        internalType: "string",
        name: "description",
        type: "string",
      },
    ],
    name: "propose",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "proxiableUUID",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "targets",
        type: "address[]",
      },
      {
        internalType: "uint256[]",
        name: "values",
        type: "uint256[]",
      },
      {
        internalType: "bytes[]",
        name: "calldatas",
        type: "bytes[]",
      },
      {
        internalType: "bytes32",
        name: "descriptionHash",
        type: "bytes32",
      },
    ],
    name: "queue",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "blockNumber",
        type: "uint256",
      },
    ],
    name: "quorum",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "quorumDenominator",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "quorumNumerator",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "target",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "relay",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "newProposalThreshold",
        type: "uint256",
      },
    ],
    name: "setProposalThreshold",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "newVotingDelay",
        type: "uint256",
      },
    ],
    name: "setVotingDelay",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "newVotingPeriod",
        type: "uint256",
      },
    ],
    name: "setVotingPeriod",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "proposalId",
        type: "uint256",
      },
    ],
    name: "state",
    outputs: [
      {
        internalType: "enum IGovernorUpgradeable.ProposalState",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "timelock",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "token",
    outputs: [
      {
        internalType: "contract IVotesUpgradeable",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "newQuorumNumerator",
        type: "uint256",
      },
    ],
    name: "updateQuorumNumerator",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract ITimelock",
        name: "newTimelock",
        type: "address",
      },
    ],
    name: "updateTimelock",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newImplementation",
        type: "address",
      },
    ],
    name: "upgradeTo",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newImplementation",
        type: "address",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "upgradeToAndCall",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [],
    name: "version",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "votingDelay",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "votingPeriod",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    stateMutability: "payable",
    type: "receive",
  },
];

const _bytecode =
  "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";

type GovernorModuleConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: GovernorModuleConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class GovernorModule__factory extends ContractFactory {
  constructor(...args: GovernorModuleConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override deploy(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<GovernorModule> {
    return super.deploy(overrides || {}) as Promise<GovernorModule>;
  }
  override getDeployTransaction(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  override attach(address: string): GovernorModule {
    return super.attach(address) as GovernorModule;
  }
  override connect(signer: Signer): GovernorModule__factory {
    return super.connect(signer) as GovernorModule__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): GovernorModuleInterface {
    return new utils.Interface(_abi) as GovernorModuleInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): GovernorModule {
    return new Contract(address, _abi, signerOrProvider) as GovernorModule;
  }
}
